import { previewShouldShowPostPurchaseChanges } from 'bundles/coursera-plus-common/utils/subscriptionsForwardDiscoveryExperiment';
import type CartsV2 from 'bundles/naptimejs/resources/carts.v2';
import {
  googleCourseListForStripeRollout,
  stripeRolloutCourseListIncludingGoogle,
} from 'bundles/payments/common/stripeRolloutCourseList';

// TODO: Delete this function when Stripe is fully rolled out
// https://coursera.atlassian.net/browse/PAYPLAT-3089
export const isNonUpsellCourse = (cart: CartsV2) => {
  // Courses with promo discount applied won't be exactly $49 for the $49 course -> $49 C+ upsell
  // BRL has geo pricing, only R$282 course is eligible for upsell
  // Also Guided Projects and Projects don't trigger course upsell
  if (
    cart.hasDiscount ||
    cart.isForGuidedProject ||
    cart.isForSelfPacedProject ||
    (cart.currencyCode === 'BRL' && cart.totalAmount !== 282)
  ) {
    return true;
  }
  return (
    stripeRolloutCourseListIncludingGoogle.includes(cart.productItemId) &&
    !(previewShouldShowPostPurchaseChanges() && googleCourseListForStripeRollout.includes(cart.productItemId))
  );
};
